import React from "react";
import style from "./index.module.scss";

const Card = (porps) => {
  const post = porps.post;
  return (
    <div className={style.card}>
      <picture className="img-frame">
        <source srcSet={post.img.lg} media="(min-width: 768px)"/>
        <img src={post.img.sm} alt="示意圖"/>
      </picture>
      <div className={style['card-body']}>
        <h2 className={style['card-title']}>{post.title}</h2>
        <p>{post.text}</p>
        <p className={style.align}>
          <a href={post.link} className="btn" target="_blank" rel="noreferrer noopener">READ MORE+</a>
        </p>
      </div>
    </div>
  )
};

export default Card;
